import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateAdjustmentEntity } from '../../domain/entities/CreateUpdateAdjustmentEntity'
import type { AdjustmentType } from '../../domain/enums/AdjustmentType'

export class CreateUpdateAdjustmentModel extends CreateUpdateAdjustmentEntity {
  driverId!: number
  declare amount: number
  declare type: AdjustmentType
  adjustmentReasonId!: number
  declare note?: string
  declare effectiveDate: string
  constructor(dataDto: CreateUpdateAdjustmentEntity) {
    super()
    mapEntityProperties<CreateUpdateAdjustmentModel>(this, dataDto, {
      exclude: ['driver', 'adjustmentReason'],
      map: {
        driverId: dataDto.driver?.id,
        adjustmentReasonId: dataDto.adjustmentReason?.id
      }
    })
  }
}
